import AffiliatesLandingPageHero from '@root/joinroot.com/src/components/affiliates/affiliates-landing-page-hero';
import AllProductsAvailabilitySection from '@root/joinroot.com/src/components/all-products-availability';
import Caret from '@root/joinroot.com/src/assets/components/brand-bling/root-caret';
import ContentfulCustomReactComponentFactory from '@root/joinroot.com/test/support/factories/contentful-custom-react-component-factory';
import CovidDriving from '@root/joinroot.com/src/components/covid-driving';
import PropTypes from '@root/vendor/prop-types';
import QuoteHeaderLegacy from '@root/joinroot.com/src/components/quote-header-legacy';
import StaticAspectRatioHero from '@root/joinroot.com/src/components/static-aspect-ratio-hero';
import { graphql } from 'gatsby';

export const graphQlFragment = graphql`
fragment ContentfulCustomReactComponent_fragment on ContentfulCustomReactComponent {
  sys {
    contentType {
      sys {
        id
      }
    }
  }
  id
  componentId
  anchor {
    anchorSlug
  }
}
`;

export default class ContentfulCustomReactComponent {
  constructor({ componentId = null } = {}) {
    this.componentId = componentId;
    this.componentToRender = Object.values(ContentfulCustomReactComponent.IDS).includes(componentId)
      && ContentfulCustomReactComponent.ID_TO_COMPONENT_MAP[componentId];

    if (!this.componentToRender) {
      throw new Error(`No component found to render for id '${this.componentId}'.`);
    }
  }

  static createFromGraphqlContent(content = {}) {
    return new ContentfulCustomReactComponent({
      componentId: content.componentId,
      anchor: content.anchor && content.anchor.anchorSlug,
    });
  }

  static graphQlDataFactory = ContentfulCustomReactComponentFactory;

  static graphQlFragment = graphQlFragment;

  static propType() {
    return PropTypes.shape({
      id: PropTypes.string.isRequired,
      componentId: PropTypes.string.isRequired,
      anchor: PropTypes.shape({
        id: PropTypes.string,
        anchorSlug: PropTypes.string,
      }),
    }).isRequired;
  }

  static IDS = {
    COVID_DRIVING: 'covid-driving',
    QUOTE_HEADER_LEGACY: 'quote-header-legacy',
    BRAND_BUILDING_HERO: 'brand-building-hero',
    AFFILIATES_LANDING_PAGE_HERO: 'affiliates-landing-page-hero',
    EXAMPLE_COMPONENT_ID: 'example-component-id',
    ALL_PRODUCTS_AVAILABILITY_SECTION: 'all-products-availability-section',
  };

  static ID_TO_COMPONENT_MAP = {
    [ContentfulCustomReactComponent.IDS.COVID_DRIVING]: CovidDriving,
    [ContentfulCustomReactComponent.IDS.QUOTE_HEADER_LEGACY]: QuoteHeaderLegacy,
    [ContentfulCustomReactComponent.IDS.BRAND_BUILDING_HERO]: StaticAspectRatioHero,
    [ContentfulCustomReactComponent.IDS.AFFILIATES_LANDING_PAGE_HERO]: AffiliatesLandingPageHero,
    [ContentfulCustomReactComponent.IDS.EXAMPLE_COMPONENT_ID]: Caret,
    [ContentfulCustomReactComponent.IDS.ALL_PRODUCTS_AVAILABILITY_SECTION]: AllProductsAvailabilitySection,
  };
}
